// A'gong Export — Supply Chain — scroll animations
document.addEventListener('DOMContentLoaded', function () {
  if (!document.querySelector('[data-agong-supply]')) return;

  if (!window.IntersectionObserver) {
    document.querySelectorAll('[data-agong-supply-anim]').forEach(function (el) {
      el.classList.add('is-visible');
    });
    return;
  }

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-visible');
      observer.unobserve(entry.target);
    });
  }, { threshold: 0.12 });

  document.querySelectorAll('[data-agong-supply-anim]').forEach(function (el) {
    observer.observe(el);
  });
});
